import { companyInfo, contactInfo } from '../data/mockData';
import { SITE_ORIGIN } from '../data/siteSeo';

const businessId = `${SITE_ORIGIN}/#business`;
const websiteId = `${SITE_ORIGIN}/#website`;

// Only published business details: no self-serving review markup or invented branches.
export const buildSiteSchema = (page) => {
  const graph = [
    {
      '@type': 'LocalBusiness', '@id': businessId,
      name: companyInfo.name, url: `${SITE_ORIGIN}/`, logo: companyInfo.logo,
      image: companyInfo.repairCentreImage,
      description: '3D printer repair and maintenance. Australia-wide send-in support and scheduled on-site service where available and practical.',
      telephone: contactInfo.phone, email: contactInfo.email,
      address: {
        '@type': 'PostalAddress', streetAddress: '781 High Street',
        addressLocality: 'Reservoir', addressRegion: 'VIC', postalCode: '3073', addressCountry: 'AU',
      },
      areaServed: { '@type': 'Country', name: 'Australia' },
      identifier: { '@type': 'PropertyValue', propertyID: 'ABN', value: contactInfo.abn.replace('ABN: ', '') },
      contactPoint: { '@type': 'ContactPoint', telephone: contactInfo.phone, contactType: 'Repairs and service — option 2', availableLanguage: 'English' },
    },
    {
      '@type': 'WebSite', '@id': websiteId, url: `${SITE_ORIGIN}/`,
      name: '3D Printer Gear Service & Repair', publisher: { '@id': businessId }, inLanguage: 'en-AU',
    },
  ];
  // The SEO templates already provide their own page/service/FAQ graph.
  if (!page.slug && page.canonical) graph.push({
    '@type': 'WebPage', '@id': `${page.canonical}#webpage`, url: page.canonical,
    name: page.title, description: page.description, inLanguage: 'en-AU',
    isPartOf: { '@id': websiteId }, about: { '@id': businessId },
  });
  if (page.path === '/') graph.push({
    '@type': 'FAQPage', '@id': `${page.canonical}#faq`,
    mainEntity: page.faqs.map(({ question, answer }) => ({
      '@type': 'Question', name: question, acceptedAnswer: { '@type': 'Answer', text: answer },
    })),
  });
  return { '@context': 'https://schema.org', '@graph': graph };
};

export const serializeSchema = (schema) => JSON.stringify(schema).replace(/</g, '\\u003c');